import React from "react";

import { faPen } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Text } from "@performyard/py-components";

import { GeneratedContentContainer } from "./GeneratedContentContainer";
import { GoalPreviewCard } from "./GoalPreviewCard";

import type { GoalSuggestionState } from "../types";

type GoalSuggestionsContainerProps = {
	suggestionStates: GoalSuggestionState[];
	onCreateGoal: (suggestionId: string) => void;
	onDeleteGoal: (suggestionId: string) => void;
	onEditGoals?: () => void;
	creatingSuggestionIds?: Set<string>;
};

export const GoalSuggestionsContainer: React.FC<GoalSuggestionsContainerProps> = ({
	suggestionStates,
	onCreateGoal,
	onDeleteGoal,
	onEditGoals,
	creatingSuggestionIds,
}) => {
	const visibleSuggestions = suggestionStates.filter((gs) => gs.status !== "deleted");
	const allDeleted = visibleSuggestions.length === 0;
	const hasPending = suggestionStates.some((gs) => gs.status === "pending");

	return (
		<GeneratedContentContainer
			title="Suggested Goals"
			headerAction={
				onEditGoals && hasPending ? { label: "Edit Goals", iconLeft: faPen, onClick: onEditGoals } : undefined
			}
		>
			{allDeleted ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested goals have been removed.
				</Text>
			) : (
				visibleSuggestions.map((gs) => (
					<GoalPreviewCard
						key={gs.suggestion.id}
						suggestionState={gs}
						onCreateGoal={() => onCreateGoal(gs.suggestion.id)}
						onDeleteGoal={() => onDeleteGoal(gs.suggestion.id)}
						isCreating={creatingSuggestionIds?.has(gs.suggestion.id)}
					/>
				))
			)}
		</GeneratedContentContainer>
	);
};

export default GoalSuggestionsContainer;
